import { FC, useState } from "react"

import { TitledCheckbox } from "components/inputs/TitledCheckbox"

import { TableColumnsInterface } from "constants/interfaces"

import { DropdownButton } from "../buttons/DropdownButton"

interface IProps {
  columns: TableColumnsInterface[]
  setColumns: (columns: TableColumnsInterface[]) => void
}

export const TableColumnsFilter: FC<IProps> = (props) => {
  const { columns, setColumns } = props
  const [open, setOpen] = useState<boolean>(false)

  const handleValueChange = (column: TableColumnsInterface): void => {
    setColumns(columns.map((cItem) => (cItem.value === column.value ? { ...cItem, selected: !column.selected } : cItem)))
  }

  return (
    <div className="relative">
      <DropdownButton value="Columns Filter" handler={() => setOpen(!open)} />
      {open ? (
        <div className="z-50 mt-2 absolute bg-white text-black border-gray-200 dark:bg-[#0C0C1A] dark:text-white dark:border-[rgba(255,255,255,0.1)]">
          <ul className="rounded-md text-md text-black dark:text-white max-h-[300px] overflow-auto">
            {columns.map((column, key) => (
              <li key={key} className="px-4 py-2 hover:text-grey-light hover:dark:bg-[#16162b] cursor-pointer">
                <TitledCheckbox title={column.title} checked={column.selected ?? false} onChange={() => handleValueChange(column)} />
              </li>
            ))}
          </ul>
        </div>
      ) : (
        ""
      )}
    </div>
  )
}
